import React, { useState } from 'react';
import { IconLoader2, IconMessage2 } from '@tabler/icons-react';
import { pb } from '../../../shared/api/pocketbase';

interface Props {
  leadId: string;
  onNotify: (msg: string) => void;
}

const errorMessage = (status?: number): string => {
  switch (status) {
    case 400: return 'Не заполнены данные для отправки SMS';
    case 403: return 'Нет прав на отправку SMS';
    case 404: return 'Группа или карточка не найдены';
    case 500: return 'Провайдер не отправил SMS';
    default: return 'Ошибка при отправке SMS';
  }
};

// ponytail: кнопка видна всем; права проверяет бэкенд и возвращает ошибку
const SmsButton: React.FC<Props> = ({ leadId, onNotify }) => {
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    setSending(true);
    try {
      const res = await pb.send<{ status: string; phone: string }>('/api/sms/send-by-group', {
        method: 'POST',
        query: { taskId: leadId },
      });
      onNotify(`SMS отправлено на ${res.phone}`);
    } catch (err) {
      onNotify(errorMessage((err as { status?: number })?.status));
    } finally {
      setSending(false);
    }
  };

  return (
    <button className="btn-sms" type="button" onClick={handleSend} disabled={sending}>
      {sending
        ? <IconLoader2 size={16} stroke={2} className="spin" />
        : <IconMessage2 size={16} stroke={1.9} />}
      SMS
    </button>
  );
};

export { SmsButton };
